function initCampaignHero(scope = document) {
  scope.querySelectorAll('[data-campaign-second]').forEach((hero) => {
    if (hero.dataset.campaignReady) return
    const image = hero.querySelector('.home-hero__backdrop img, .utility-hero__backdrop img')
    const controls = hero.querySelector('[data-campaign-controls]')
    if (!image || !controls) return
    hero.dataset.campaignReady = 'true'
    controls.hidden = false
    const scenes = [
      { src: image.currentSrc || image.src, alt: image.alt },
      { src: hero.dataset.campaignSecond, alt: hero.dataset.campaignSecondAlt || 'Second campaign scene' },
    ]
    let index = 0
    let changing = false
    controls.addEventListener('click', async (event) => {
      const trigger = event.target.closest('[data-campaign-step]')
      if (!trigger || changing) return
      changing = true
      const next = (index + Number(trigger.dataset.campaignStep) + scenes.length) % scenes.length
      const preload = new Image()
      preload.src = scenes[next].src
      try {
        await preload.decode()
        const frozen = image.cloneNode()
        frozen.removeAttribute('srcset')
        frozen.removeAttribute('sizes')
        frozen.setAttribute('aria-hidden', 'true')
        frozen.className = 'campaign-previous-frame'
        image.parentNode.insertBefore(frozen, image)
        image.removeAttribute('srcset')
        image.removeAttribute('sizes')
        image.src = scenes[next].src
        image.alt = scenes[next].alt
        await image.decode()
        index = next
        controls.querySelector('[data-campaign-count]').textContent = String(index + 1).padStart(2, '0') + ' / 02'
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          await image.animate([{opacity:0},{opacity:1}], {duration:650,easing:'cubic-bezier(.16,1,.3,1)'}).finished
        }
        frozen.remove()
      } catch {
        hero.querySelector('.campaign-previous-frame')?.remove()
      } finally { changing = false }
    })
  })
}

initCampaignHero()
document.addEventListener('shopify:section:load', event => initCampaignHero(event.target))
